export function dynamicallyFormatDate(dateString: string) {
    if (dateString.length === 4 || dateString.length === 7) {
        return dateString + "-";
    } else if (dateString.length === 10) {
        return dateString + " ";
    } else if (dateString.length === 13) {
        return dateString + ":";
    }
    return dateString;
}

export function getMonday(d: Date) {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}

export function getMidnight(d: Date) {
    d.setHours(0, 0, 0, 0);
}

export function getShortDateDisplayStr(dat: string | null) {
    if (dat === null) {
        return "";
    }
    return getShortDateDisplay(new Date(dat));
}

export function getShortDateDisplay(dat: Date) {
    const now = new Date();
    return getRelativeShortDisplay(now, dat);
}

export function getRelativeShortDisplay(ref: Date, dat: Date | null) {
    if (dat == null) return "";
    const ref_ts = ref.getTime();
    ref.setHours(0, 0, 0, 0);
    const ref_midnight_ts = ref.getTime();
    const dat_ts = dat.getTime();
    const wd = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    if (
        dat_ts > ref_midnight_ts &&
        dat_ts < ref_midnight_ts + 60 * 60 * 27 * 1000
    ) {
        // today
        let h = dat.getHours();
        let m = dat.getMinutes();
        return ("0" + h).slice(-2) + ":" + ("0" + m).slice(-2);
    } else if (
        dat_ts > ref_midnight_ts - 60 * 60 * 24 * 1000 &&
        dat_ts < ref_midnight_ts
    ) {
        // yesterday
        let h = dat.getHours();
        let m = dat.getMinutes();
        return "-" + ("0" + h).slice(-2) + ":" + ("0" + m).slice(-2);
    } else if (
        dat_ts > ref_midnight_ts &&
        dat_ts < ref_midnight_ts + 60 * 60 * 51 * 1000
    ) {
        // tomorrow
        let h = dat.getHours();
        let m = dat.getMinutes();
        return "+" + ("0" + h).slice(-2) + ":" + ("0" + m).slice(-2);
    } else if (
        dat_ts > ref_midnight_ts &&
        dat_ts < ref_midnight_ts + 60 * 60 * 75 * 1000
    ) {
        // the day after tomorrow
        let h = dat.getHours();
        let m = dat.getMinutes();
        return "x" + ("0" + h).slice(-2) + ":" + ("0" + m).slice(-2);
    } else if (
        dat_ts > ref_ts - 60 * 60 * 168 * 1000 &&
        dat_ts < ref_ts + 60 * 60 * 24 * 21 * 1000
    ) {
        // last week, this week, next week
        return "" + dat.getDate() + " " + dat.getHours() + "h";
    } else if (
        dat_ts - 60 * 60 * 24 * 3 * 1000 < ref_ts &&
        ref_ts < dat_ts + 60 * 60 * 24 * 30 * 1000
    ) {
        // this year
        let c = ref_ts < dat_ts ? "+" : "-";
        return wd[dat.getDay()] + c + dat.getDate();
    } else if (
        dat_ts - 60 * 60 * 24 * 356 * 1000 < ref_ts &&
        ref_ts < dat_ts + 60 * 60 * 24 * 356 * 1000
    ) {
        return "" + dat.getDate() + "/" + (dat.getMonth() + 1);
    } else {
        return dat.getFullYear();
    }
}
